import { Modal, Text, Stack, Flex, Button, Divider } from '@mantine/core';

interface UnApplyConfirmModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  jobTitle: string;
  isLoading?: boolean;
}

/**
 * Confirmation modal shown when user attempts to un-apply from a job.
 * Prevents accidental un-apply actions.
 */
function UnApplyConfirmModal({
  opened,
  onClose,
  onConfirm,
  jobTitle,
  isLoading = false,
}: UnApplyConfirmModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      withCloseButton
      title={
        <Text fw={700} size="xl">
          Confirm Un-Apply
        </Text>
      }
    >
      <Stack gap="md" align="center" ta="center">
        <Text>
          Are you sure you want to un-apply from <strong>{jobTitle}</strong>?
        </Text>

        <Divider w="100%" />

        <Flex justify="center" gap="sm">
          <Button
            variant="filled"
            color="red"
            onClick={onConfirm}
            loading={isLoading}
            size="sm"
          >
            Un-Apply
          </Button>
          <Button
            variant="default"
            onClick={onClose}
            disabled={isLoading}
            size="sm"
          >
            Cancel
          </Button>
        </Flex>
      </Stack>
    </Modal>
  );
}

export default UnApplyConfirmModal;
